// extracted by mini-css-extract-plugin
module.exports = {"tabSwitch":"tabSwitch_tabSwitch__9J1TF","tabs":"tabSwitch_tabs__LsCmm","tab":"tabSwitch_tab__J0V9C","active":"tabSwitch_active__M7MBg","depositBtn":"tabSwitch_depositBtn__L5vii"};